function ajaxSubmitCart(t) {
    ($cart = t),
        $.ajax({
            url: "/cart/update.js",
            dataType: "json",
            type: "post",
            data: $cart.serialize(),
            success: function (t) {
                Shopify.getCart(function (t) {
                    check_and_remove(t);
                }, t);
            },
        });
}
function ajaxUpdateCart(t, a, e) {
    $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        type: "post",
        data: { quantity: a, line: t },
        success: function (r) {
            check_and_remove(r);
            var n = t - 1;
            if (void 0 === r.items[n]) var i = 0;
            else i = r.items[n].quantity;
        },
    });
}
function removeFreeItem(t) {
    var a = { updates: {} };
    (a.updates[t] = 0),
        t == GIFT_WRAP_ID && (a.attributes = { "gift-wrapping": "", "Gift wrap message": "" }),
        $.ajax({
            url: "/cart/update.js",
            method: "POST",
            dataType: "json",
            async: !1,
            data: a,
            success: function (t) {
                check_and_remove(t);
            },
            error: function (t) {
                console.log(t);
            },
        });
}
function isFree(t) {
    var a = !1;
    return (
        $(t).each(function (t, e) {
            "free" in e && (a = !0);
        }),
        a
    );
}
function currentTier(t) {
    var a = 0;
    return t.total_price >= 2e4 && t.total_price <= 4e4 ? (a = 200) : t.total_price > 4e4 && (a = 400), a;
}
function hasGiftCard(t) {
    for (var a = !1, e = 0; e < t.length; e++) {
        if ("gift-certificate" == t[e].handle) {
            a = !0;
            break;
        }
    }
    return a;
}
function check_and_remove(t) {
    var a = t.items,
        e = currentTier(t),
        r = window.promotiers ? window.promotiers[e] : {};
    if (!r) {
        if (1 == t.items.length && t.items[0].id == GIFT_WRAP_ID) return removeFreeItem(GIFT_WRAP_ID), !1;
        refreshCart(t);
    }
    var n = !1;
    if (Shopify.GWP_PROMO)
        for (var i = 0; i < a.length; i++) {
            var o = a[i],
                s = isFree(o.properties),
                c = o.product_id.toString();
            s && $.inArray(c, r) < 0 && (removeFreeItem(o.id), (n = !0));
        }
    n || refreshCart(t);
}
function _setText(t, e) {
    t.children().length
        ? t.children().each(function () {
            "" !== $.trim($(this).text()) && $(this).text(e);
        })
        : t.val(e).text(e);
}
function refreshCart(t) {
    var a = t.item_count > 0 ? "true" : "false",
        e = $(".cart_count"),
        r = e.text() || "0",
        n = $("#side-cart form"),
        gwp = '#free-gwp-wrapper',
        i = $(".cart-count");
    $("#main-cart");
    i.attr("data-show", a).html(t.item_count),
        e.text(r.replace(/[0-9]+/, t.item_count)),
        t.item_count > 0
            ? ($(".js-empty-cart__message").addClass("hidden"), $(".js-cart_content__form").removeClass("hidden"), refreshCartContent(t), $(".cart-subtotal-value").html(moneyFormat(t.total_price, !0)))
            : ($(".js-empty-cart__message").removeClass("hidden"), n.find(".cart__wrapper").remove(), $(".js-cart_content__form").addClass("hidden"));
            
        if(Shopify.GWP_PROMO){
            $("#prop-free-gift").remove();
            var total_price = 0,
                has_free_gwp = false,
                CURRENT_PRODUCT = window.CURRENT_PRODUCT,
                $btn = $('button.btn--add-to-cart');
            $(t.items).each(function (t, e) {
                if (e.product_type != "Gift Certificate") {
                    total_price = total_price + e.line_price;
                }
                if (e.line_price == 0) {
                    has_free_gwp = true;
                }
            });
            if (total_price >= 40000 && !has_free_gwp && CURRENT_PRODUCT.tags.indexOf('gift-3') !== -1) {
                _setText($btn, 'GET IT FOR FREE')
            } else {
                _setText($btn, 'ADD TO CART')
            }
            var o = $(".c-cart-shipping-promo"), __ids = window.promotiers.tier3;
            var tier_two_high_price =   window.promotiers.highestPrice[0]['tier2'];
            var tier_three_high_price =   window.promotiers.highestPrice[0]['tier3'];
            if (o.length && Shopify.GWP_PROMO) {
                if ($.inArray(window.CURRENT_PRODUCT.id, __ids) !== -1) {
                    o.html(
                        `GET THIS ITEM FOR FREE WITH ORDERS OVER <span data-currency data-gwp-price data-money="40000">${moneyFormat(4e4)}</span>!`
                    );
                    if (total_price >= 40000 && !has_free_gwp ) {
                        $('form[action="/cart/add"]').append('<input type="hidden" name="properties[_free]" value="1" id="prop-free-gift" />');
                    }
                } else {
                    if (total_price < 2e4) {
                        o.html(
                            'SPEND OVER <span data-currency data-gwp-price data-money="20000">' +
                            moneyFormat(2e4) +
                            '</span> TO CHOOSE A FREE ELIGIBLE Clutch or WALLET (worth up to <span data-tier2 data-currency data-gwp-price data-money="' + tier_two_high_price + '">' +
                            moneyFormat(tier_two) + "</span>)."
                        );
                    } else {
                        o.html(
                            'SPEND OVER <span data-currency data-gwp-price data-money="40000">' +
                            moneyFormat(4e4) +
                            '</span> TO CHOOSE a FREE eligible crossbody, wallet OR SUNGLASSES (worth up to <span data-tier3 data-currency data-gwp-price data-money="' + tier_three_high_price + '">' +
                            moneyFormat(tier_three) +
                            "</span>)."
                        );
                    }
                }
            }
        }

    window.Currency.updatePrices(),
    $(".site-nav__cart__count").html("(" + t.item_count + ")"),
    "cart" == template &&
    Shopify.getCartHtml(function (a) {
        $(Shopify.GWP).html($(a).find(Shopify.GWP).html());
        if ($(a).find(gwp).length) {
            $(gwp).html($(a).find(gwp).html());
        }else{
            $('#free-barca').remove();
        }
        $("#main-cart").html($(a).find("#main-cart").html()),
        warnBeforeCheckout(),
        promoSlider(),
        0 == t.item_count && $("#shopify-section-related-products").remove(),
        window.Currency.updatePrices(),
        $(window).width() > 767 && $("table.cart__table thead").removeClass("small--hide");
    })
}
function updateOnLoad() {
    $.ajax({
        url: "/cart.js",
        dataType: "json",
        type: "get",
        success: function (a) {
            if (a.item_count) {
                $(".cart-count").html(a.item_count).attr('data-show', true);
            } else {
                $(".cart-count").empty().attr('data-show', false);
            }
            refreshCartContent(a);
        },
    });
}


updateOnLoad()
function refreshCartContent(t) {
    var a = $("#side-cart form"),
        e = '<div class="js-empty-cart__message  hidden ">YOUR CART IS CURRENTLY EMPTY.</div>',
        only_giftcard = true, has_freegift = false, has_gift_wrap = false;
    $(t.items).each(function (i, it) {
        if (it.line_price == 0) has_freegift = true;
        if ("Gift Certificate" != it.product_title) only_giftcard = false;
        if (GIFT_WRAP_ID == it.id) has_gift_wrap = true;
    });

    if (t.items.length) {
        $.get('/cart?view=custom', function (json) {
            var cart = JSON.parse(json),
                is_all_seconds = !0;
            items = cart.items;
            $(items).each(function (i, opt) {
                var item = opt.item;
                var sign = false;
                var isGuaranteeProduct = false;
                var a = ((item = t.items[i]).handle, item.product_title);
                var opt_by = item.variant_title ? item.variant_title : "";
                var s = moneyFormat(item.line_price);
                var nextReplicaIndex = i + 1;
                var comp_price = parseInt(opt.compare_at_price);
                if (0 == item.line_price) {
                    sign = true;
                }
                if (item.handle == 'parcel-protection') {
                    isGuaranteeProduct = true;
                }
                var d = sign || "Gift Wrapping" == item.product_title || isGuaranteeProduct ? '<input class="quantity" type="number" readonly value="' + item.quantity + '">' : '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span><input class="quantity" data-line-id="' + nextReplicaIndex + '" type="number" name="updates[]" value="' + item.quantity + '" min="0" aria-label="Item quantity"><span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
                e += `<div class="cart__wrapper">
              <div class="first">
                  <a href="${item.url}" ${isGuaranteeProduct ? 'style="pointer-events:none;cursor: default;" onclick="return false"':''}>
                      <img src="${opt.grey_image}" alt="${item.title}">
                  </a>
              </div>
              <div class="second" ${isGuaranteeProduct? 'style="flex-basis:calc(100% - 110px)"' : ''}>
                <a href="${item.url}" ${isGuaranteeProduct ? 'style="pointer-events:none;cursor: default;" onclick="return false"':''}><h3>${a}</h3></a>
                <p>${opt_by}</p>`;

            if(isGuaranteeProduct){
                e += `<p class="cart__parcel_note">If your parcel is lost or damaged in transit, we'll send you a replacement the next business day!</p>`;
            }
            if(!isGuaranteeProduct){
                e += `<div class="line-item-price mobile-hide">
                    ${(!sign ? '<span'+ (comp_price && comp_price > item.original_price ? ' class="sale-final-price"' : '')+' style="padding-right:10px;" data-currency data-money="' + item.original_price + '">' + moneyFormat(item.original_price) + "</span>" : '<span style="padding-right:10px;">FREE</span>')}`;
                if (item.line_price > 0) {
                    e += `${(comp_price && comp_price > item.original_price ?
                        '<s data-currency data-money="' + comp_price + '">' + moneyFormat(comp_price) + "</s>" : "")}`;
                } else {
                    var pr = comp_price > item.original_price ? comp_price : item.original_price;
                    e += `<s data-currency data-money="${pr}">${moneyFormat(pr)}</s>`;
                }
                e += `</div>`;
            }
                e += `</div>`;
            if(!isGuaranteeProduct){
              e += `<div class="third medium-down--show large--hide widescreen--hide">${d}</div>      
              <div class="third medium-down--hide">${d}</div>`;
                e += sign ? '<div class="fourth cart__item-subtotal index-' + nextReplicaIndex + '">FREE</div>' : '<div data-currency data-money="' + item.line_price + '" class="fourth cart__item-subtotal index-' + nextReplicaIndex + '">' + s + "</div>";
            }
                e += "</div>";

                var is_second = false;
                if (opt.tags.indexOf(theme.strings.secondsTag) !== -1 || opt.tags.indexOf(theme.strings.overstockTag) !== -1) {
                    is_second = true;
                }
                if (!is_second && item.handle.indexOf('gift') < 0) {
                    is_all_seconds = !1;
                }
            });

            $(".cart__list").html(e),
                $(".js-change-quantity").removeClass("disabled");
            a.find(".cart__subtotal").html('<div>Subtotal</div><div class="cart__total" data-currency="" data-money="' + t.total_price + '">' + moneyFormat(t.total_price) + "</div>");
            $(".side-cart__footer").removeClass("hidden"),
                $(".js-cart_content__form").removeClass("hidden"),
                $(".js-empty-cart__message").addClass("hidden");
            var remove_wrap = is_all_seconds ? true : (!has_gift_wrap ? true : false);
            if (remove_wrap) removeGiftWrap();
        });
    } else {
        $(".cart__list").html(e);
        a.find(".cart__subtotal").empty();
        $(".side-cart__footer").addClass("hidden"),
            $(".js-cart_content__form").addClass("hidden"),
            $(".js-empty-cart__message").removeClass("hidden");
        removeGiftWrap();
    }

}
function removeGiftWrap() {
    $.post('/cart/update.js', { attributes: { 'gift-wrapping': '', 'Gift wrap message': '' } });
}

if (
    ("undefined" == typeof Shopify && (Shopify = {}),
        (Shopify.getCart = function (t) {
            jQuery.getJSON("/cart.js", function (a, e) {
                if ("function" == typeof t) t(a);
                else if (Array.isArray(t)) for (i = 0; i < t.length; i++) "function" == typeof t[i] && t[i](a);
                else "function" == typeof Shopify.onCartUpdate && Shopify.onCartUpdate(a);
            });
        }),
        (Shopify.formatMoney = function (t, a) {
            var e = /\{\{\s*(\w+)\s*\}\}/;
            switch (((a = a || this.money_format), "string" == typeof t && (t = t.replace(/[^0-9]/g, "")), (t = (t = parseInt(t)).toString()).length)) {
                case 0:
                    t = "000";
                    break;
                case 1:
                    t = "00" + t;
                    break;
                case 2:
                    t = "0" + t;
            }
            var r = t.substr(t.length - 2),
                n = t.substr(0, t.length - 2),
                i = ",",
                o = ".";
            switch (a.match(e)[1]) {
                case "amount_no_decimals":
                    (r = ""), (o = "");
                    break;
                case "amount_with_comma_separator":
                    (i = "."), (o = ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    (i = "."), (r = ""), (o = "");
            }
            var s =
                (function (t, a) {
                    return (a = a || ","), t.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a);
                })(n, i) +
                o +
                r;
            return a.replace(e, s);
        }),
        "ajax" == cart_action &&
        $("body").on("submit", ".product_form", function (e) {
            e.preventDefault();
            var $addToCartForm = $(this),
                $addToCartBtn = $addToCartForm.find(".add_to_cart");
            return (
                $.ajax({
                    url: "/cart/add.js",
                    dataType: "json",
                    type: "post",
                    data: $addToCartForm.serialize(),
                    beforeSend: function () {
                        $addToCartBtn.attr("disabled", "disabled").addClass("disabled"), $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut");
                    },
                    success: function (t) {
                        $addToCartBtn.find(".checkmark").addClass("checkmark-active"),
                            window.setTimeout(function () {
                                $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find(".checkmark").removeClass("checkmark-active"), $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown");
                            }, 1e3),
                            Shopify.getCart(function (t) {
                                check_and_remove(t),
                                    $("html").hasClass("remodal-is-locked") && $(".remodal-close").click(),
                                    $("#header").is(":visible")
                                        ? $("#header .cart_container").addClass("active_link")
                                        : $(".sticky_nav--stick").length
                                            ? $(".sticky_nav .cart_container").addClass("active_link")
                                            : $(".top_bar .cart_container").addClass("active_link");
                            });
                    },
                    error: function (XMLHttpRequest) {
                        var response = eval("(" + XMLHttpRequest.responseText + ")");
                        (response = response.description), $(".warning").remove();
                        var warning = '<p class="warning animated bounceIn">' + response.replace("All 1 ", "All ") + "</p>";
                        $addToCartForm.after(warning), $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find("span").text(add_to_cart_t).removeClass("zoomOut").addClass("zoomIn");
                    },
                }),
                !1
            );
        }),
        "swatches" == product_form_style)
) {
    if ($(".js-product_section").length) {
        var $productForms = $(".js-product_section").find(".product_form");
        $productForms.each(function () {
            var t = $(this).data("product"),
                a = ".product-" + $(this).data("product-id") + " .js-product_section";
            $(this).find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(t, a);
        });
    }
    $(".js-product_section").length > 1 &&
        $("body").on("click", ".swatch-element", function () {
            var t = $(this).data("value");
            $(this)
                .siblings('input[value="' + t.replace(/\"/g, '\\"') + '"]')
                .prop("checked", !0)
                .trigger("change");
            var a = $(this).parents(".product_form").data("product"),
                e = ".product-" + $(this).parents(".product_form").data("product-id") + " .js-product_section";
            $(this).parents(".product_form").find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(a, e);
        });
}

function jsQuantitySelector() {
    var t = $(this),
        a = $(this).siblings("input"),
        e = parseInt(a.val()),
        r = 1e29,
        n = a.attr("min") || 0;
    t.parents(".cart-edit-modal").length || $(".js-change-quantity").addClass("disabled");
    var i = $(this).attr("data-inventory_policy");
    if (($("#sold-out-msg").remove(), null != a.attr("max") && (r = a.attr("max")), isNaN(e) || e < n)) return a.val(n), !1;
    if (e > r) return a.val(r), !1;
    if ("plus" == t.data("func")) {
        //         if (void 0 !== i && !1 !== i && "deny" == i) if (e + 1 > $(this).attr("data-inventory_quantity")) return $(".quant-box").after('<div id="sold-out-msg"><p class="warning warning--quantity">0 item left</p></div>'), !1;
        e < r && a.val(e + 1);
    } else e > n && a.val(e - 1), t.parents(".cart_item").length && e - 1 == 0 && t.closest(".cart_item").addClass("animated fadeOutUp");
    a.trigger("change");
}


function setGiftMessage() {
    if (0 == $("#giftwrap-message").length) return $('[name="checkout"]').click(), !0;
    var t = $("#giftwrap-message").val();
    $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: { attributes: { "gift-wrapping": !0, "Gift wrap message": t } },
        dataType: "json",
        success: function () {
            $('[name="checkout"]').click();
        },
    });
}


function getCustomCart(callback) {
    $.ajax({
        url: `https://${window.location.hostname}/cart?view=custom`,
        type: 'get',
        success: callback
    });
}

function warnBeforeCheckout() {

    if (isGiftWrappingDisabled) return !0;

    $(document).on("click",".cart-warning-modal .continue-btn",function () {
        $(this).addClass('pseudo-loading');
        setGiftMessage();
    });

    $(".cart-checkout-btn").on("click", function (t) {
        t.preventDefault();
        $(this).addClass('pseudo-loading');
        var a = $(this);
        $('form[action="/cart"]');
        // a.prop("disabled", !0).addClass("inverted disabled");
          if (Shopify.GWP_PROMO){
                    var e = window.promotiers,
                tier_1_2 = e['tier1'].concat(e['tier2']),
                r = tier_1_2.concat(e['tier3']);
          }

          var n = $(".cart-warning-modal");

        getCustomCart(function (t) {
            t = JSON.parse(t);
            var e = !1, is_all_seconds = !0;
            // if (Shopify.GWP_PROMO) return setGiftMessage(), !1;
            for (var i = t.items, o = 0; o < i.length; o++) {
                var s = i[o].item,
                    item = i[o],
                    c = s.product_id;
                if (s.line_price == 0 && $.inArray(c, r) > -1 && Shopify.GWP_PROMO) {
                    e = !0;
                    // break;
                }
                if (Shopify.FREE_BARCELONA && Shopify.FREEGIFT_IDS.split(',').indexOf(c.toString()) > -1 && 0 == s.line_price) {
                    e = !0;
                    // break;
                }
                var p_title = s.title.toLowerCase(), is_second = false;
                if (item.tags.indexOf(theme.strings.secondsTag) !== -1 || item.tags.indexOf(theme.strings.overstockTag) !== -1) {
                    is_second = true;
                }
                if (!is_second && s.handle.indexOf('gift') < 0 && s.handle.indexOf('parcel-protection') < 0) {
                    is_all_seconds = !1;
                }

            }
            
            if (is_all_seconds) {
                $('[name="checkout"]').click();
                return;
            }

            a.prop("disabled", !1).removeClass("inverted disabled");
            if(e){ 
                setGiftMessage() 
            }else{
                n.show();
                a.removeClass('pseudo-loading')
            }
        });
    });
}
$(document).on('click', ".scroll-btn", function () {
    $(".cart-warning-modal").fadeOut(), $("html").removeClass("modal-open"), $("html, body").animate({ scrollTop: 0 }, "slow");
});
$(".cart-warning-modal").click(function (t) {
    $(t.target).closest(".modal-body").length || ($(".cart-warning-modal").fadeOut(), $("html").removeClass("modal-open"));
});
warnBeforeCheckout();